//Students
export const SELECT_STUDENT = "SELECT_STUDENT";

//App
export const CHANGE_PAGE = "CHANGE_PAGE";
export const CHANGE_USER = "CHANGE_USER";
export const SET_PRIVACY_SETTINGS = "SET_PRIVACY_SETTINGS";
export const CHANGE_PRIVACY_SETTINGS = "CHANGE_PRIVACY_SETTINGS";